import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseComponent from 'base-component';

import numeral from 'numeral';

import {ButtonViewStore, ProgressButtonViewStore} from './viewstore';
import {ButtonContentModel, ProgressButtonContentModel} from './contentmodel';


@observer
export class ButtonComponent extends BaseComponent {

    static get ViewStore() {
        return ButtonViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
            form
        } = this.props;

        const {
            label,
            tooltip,
            action,
            disabled,
            css,
            tabindex,
        } = contentModel; // this contentModel's properties

        const {
            invalid,
            save,
            onClick,
            errorMessage,
        } = this.viewStore; // this component's viewStore.  Will have actions and UI properties

        if((form.props.contentModel.submitAction == "proceed" && form.props.contentModel.isSubmitted) || contentModel.id == "ProgressButton_996") {
            return <div></div>;
        }


        if(errorMessage) {
          return (
            <div className="btn-progress-container right">
                <div className={"btn " + css + " error btn-progress disabled"}>
                    {form.updating && <i className="fa fa-spinner fa-spin"></i>}
                    <span className="btn-label" dangerouslySetInnerHTML={{__html: label}}></span>
                </div>
                <span className="progress-bar-label" style={{color:'red'}}>{errorMessage}</span>
            </div>
          )
        }

        return (
            <div className="btn-progress-container right">
                <div className={"btn " + css + " btn-progress" + (disabled || form.props.contentModel.isSubmitted || this.viewStore.isClicked || form.updating ? " disabled " : "")} onClick={onClick}>
                    {form.updating && <i className="fa fa-spinner fa-spin"></i>}
                    <span className="btn-label" dangerouslySetInnerHTML={{__html: label}}></span>
                </div>
                <span className="progress-bar-label"></span>
            </div>
        )
    }
}


@observer
export class ProgressButtonComponent extends BaseComponent {

    static get ViewStore() {
        return ProgressButtonViewStore;
    }
  
    render() {
        const {
            currentView, // the parent view container, may have options etc attached depending on context
            contentModel, // the hydrated contentModel
            form
        } = this.props;

        const {
            label,
            tooltip,
            action,
            disabled,
            css,
            tabindex,
        } = contentModel; // this contentModel's properties

        const {
            invalid,
            save,
            onClick,
            progress,
        } = this.viewStore; // this component's viewStore.  Will have actions and UI properties

        const percent = numeral(form.props.contentModel.isSubmitted ? 1 : progress).format("0,0%");
        
        if(form.dbVariableStore["G:FI_RES_CapitalRemainingInStream1:G"] < 0 || form.dbVariableStore["G:FI_RES_CapitalRemainingInStream2:G"] < 0 || form.dbVariableStore["G:FI_RES_CapitalRemainingInStream3:G"] < 0 || 
              (form.props.contentModel.id.indexOf('activity_680096016') < 0 && window.application.shell && window.application.shell.needsStrategy)) {
            return (
                <div className="btn-progress-container right">
                    <div className={"btn " + css + " btn-progress disabled"}>
                        <span className="btn-label" dangerouslySetInnerHTML={{__html: label}}></span>
                    </div>
                    <span className="progress-bar-label" style={{color: 'red'}}>{window.application.shell && window.application.shell.needsStrategy ? "You must finalize your strategy." : "You have exceeded your budget."}</span>
                </div>
            );
        }

        return (
            <div className="btn-progress-container right">
                <div className={"btn " + css + " btn-progress" + (progress < 1 || form.props.contentModel.isSubmitted ? " disabled": "")} onClick={onClick}>
                    <span className="btn-label" dangerouslySetInnerHTML={{__html: label}}></span>
                </div>
            </div>
        );
    }
}


export default ButtonComponent; //need to export top level component as "default"



// WEBPACK FOOTER //
// ./app_modules/form-control-activity/buttons/component.js